export const environment = {
  firebase: {
    apiKey: 'AIzaSyDLl_C8G_OAB2qQcNJo-J93ST0gF8m3xpY',
    authDomain: 'schedule-maker-33d09.firebaseapp.com',
    projectId: 'schedule-maker-33d09',
    storageBucket: 'schedule-maker-33d09.firebasestorage.app',
    messagingSenderId: '418398056891',
    appId: '1:418398056891:web:11103b5387fc520d68149e',
    measurementId: 'G-1C9H84BJJG'
  }
};
